import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import CriteriaNumberRangeComponent from '../../components/criteria/CriteriaNumberRangeComponent';
import ChallengeService from '../../services/ChallengeService';
import AchievementService from '../../services/AchievementService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import CriteriaCheckboxComponent from '../../components/criteria/CriteriaCheckboxComponent';

import Constants from '../../utils/constants';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import {Button, Card, Column, DataTable, Dialog, Menu, ProgressBar} from 'primereact';
import UserChallengeService from '../../services/UserChallangeService';

class ChallengeListContainer extends BaseListContainer {
    constructor(props) {
        props.type === 'ACHIEVEMENT' ? super(props, new AchievementService()) : super(props, new ChallengeService());
        //super(props, new ChallengeService());
        this.state = {
            //type: props.type,
            list: [],
            loading: true,
            size: 0,
            renderDialog: false,
            usersInChallenge: [],
            headerForUsersInChallengeDialog: '',
            renderUsersInChallengeDialog: false,
            eventDetails: undefined,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            showConfirmRemoveDialog: false,
        };
        this.userChallengeService = new UserChallengeService();
        this.service = this.props.type === 'ACHIEVEMENT' ? new AchievementService() : new ChallengeService();
    }

    updateSearchCriteria(criteria) {
        return {
            type: criteria.type,
            locale: criteria.locale,
            title: criteria.title,
            hideExpired: criteria.hideExpired,
            coinsFrom: criteria.coinsFrom,
            coinsTo: criteria.coinsTo,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            locale: this.authService.getI18n(),
            // type: this.props.type === 'ACHIEVEMENT' ? 'ACHIEVEMENT' : 'CHALLENGE',
            hideExpired: true,
            title: '',
            coinsFrom: undefined,
            coinsTo: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: false,
        };
    }

    initializeFromBackend() {}

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'challenge.listTitle';
    }
    getCriteriaName() {
        return 'challenge-list-sc';
    }

    getContainerListName() {
        return 'challenge-list-container';
    }
    renderCriteria() {
        return (
            <div>
                <div className='row'>
                    <CriteriaTextComponent
                        id='text-sc'
                        name='title'
                        label={t('challenge.title')}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.title}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    <CriteriaNumberRangeComponent
                        id='text-sc'
                        label={t('challenge.coins_range')}
                        colClass='col-lg-4 col-sm-6'
                        idFrom='coinsFrom'
                        idTo='coinsTo'
                        nameFrom='coinsFrom'
                        nameTo='coinsTo'
                        from={this.state.criteria.coinsFrom}
                        to={this.state.criteria.coinsTo}
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                    />
                    {this.props.type === 'ACHIEVEMENT' ? null : (
                        <CriteriaCheckboxComponent
                            id='hideExpired'
                            name='hideExpired'
                            label={t('quiz.hideExpired')}
                            value={this.state.criteria.hideExpired}
                            onChange={this.handleChangeSc}
                            validator={this.validator}
                        />
                    )}
                </div>
            </div>
        );
    }

    prepareHeaderItems() {
        const {t, newUrl} = this.props;
        const href = `${newUrl}/`+sessionStorage.getItem('i18nextLng');
        return this.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR')
            ? [
                  {
                      label: t('global.addButton'),
                      onClick: () => {
                          //   window.location.href = AppPrefixUtils.locationHrefUrl(href);
                          this.props.history.push(AppPrefixUtils.locationHrefUrl(href));
                      },
                      type: 'BUTTON',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    prepareColumns() {
        return [
            {field: 'id', header: 'ID', sortable: true, width: '90px'},
            {
                field: 'status.label',
                header: t('challenge.list.status'),
                sortField: 'status',
                sortable: true,
            },
            {field: 'title', header: t('challenge.title'), sortable: false, width: '190px'},
            {field: 'coinsToEarn', header: t('challenge.coinsToEarn'), sortable: true},
            this.props.type === 'ACHIEVEMENT'
                ? {}
                : {
                      field: 'activeFrom',
                      header: t('challenge.activeFrom'),
                      sortable: true,
                      body: this.dateTemplate.bind(this, 'activeFrom', Constants.DATE_TIME_FORMAT),
                  },
            this.props.type === 'ACHIEVEMENT'
                ? {}
                : {
                      field: 'activeTo',
                      header: t('challenge.activeTo'),
                      sortable: true,
                      body: this.dateTemplate.bind(this, 'activeTo', Constants.DATE_TIME_FORMAT),
                  },
            {
                field: 'cyclical',
                header: t('challenge.cyclical'),
                body: (row) => {
                    return <div>{row.cyclical === false ? t('global.no') : t('global.yes')}</div>;
                },
            },
            {field: 'action', header: t('global.action'), body: this.actionTemplate, float: 'center'},
        ];
    }
    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderDialog() {
        return null;
    }

    actionTemplate(rowData) {
        const menuRef = React.createRef();
        const { detailUrl } = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/` + sessionStorage.getItem('i18nextLng');
    
        const menuItems = [
            this.props.type === 'CHALLENGE' && {
                label: t('global.stats'),
                icon: 'pi pi-list',
                command: () => this.getByChallengeList(rowData),
            },
            {
                label: t('global.details'),
                icon: 'pi pi-eye',
                command: () => this.handleGoToDetail(detailHref),
            }
        ].filter(Boolean); // Usuwa `false` wartości jeśli warunek nie jest spełniony
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }

    
    breadCrumbItems() {
        return [
            {
                name: this.props.type === 'ACHIEVEMENT' ? t('achievement.listTitle') : t('challenge.listTitle'),
                url: this.props.type === 'ACHIEVEMENT' ? '/achievements-list' : '/challenge-list',
            },
        ];
    }

    getByChallengeList = (rowData) => {
        console.log(rowData);
        this.userChallengeService
            .getByChallengeList(rowData.id)
            .then((res) => {
                this.setState({
                    usersInChallenge: res,
                    renderUsersInChallengeDialog: true,
                    headerForUsersInChallengeDialog: rowData.title,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('global.fetch-error'));
            });
    };
    render() {
        return (
            <div className='container-fluid'>
                {this.renderView()}
                {this.state.renderUsersInChallengeDialog && (
                    <Dialog
                        header={this.state.headerForUsersInChallengeDialog}
                        visible={this.state.renderUsersInChallengeDialog}
                        style={{width: '30vw'}}
                        closable={true}
                        onChange={() => {
                            this.setState({
                                renderUsersInChallengeDialog: false,
                            });
                        }}
                        onHide={() => {
                            this.setState({
                                renderUsersInChallengeDialog: false,
                            });
                        }}
                    >
                        <Card
                            footer={() => {
                                return <React.Fragment></React.Fragment>;
                            }}
                        ></Card>

                        <DataTable
                            value={this.state.usersInChallenge.content}
                            rows={5}
                            paginator
                            rowsPerPageOptions={[5, 10]}
                            responsiveLayout='scroll'
                            emptyMessage={t('list.empty')}
                        >
                            <Column sortable={true} field='user.fullName' header={t('user.name')}></Column>
                            <Column
                                sortable={true}
                                style={{width: '300px'}}
                                field='result'
                                align={'right'}
                                header=''
                                body={(row) => {
                                    let color = 'red';
                                    if (parseInt(row.result) >= 31 && parseInt(row.result) <= 99) {
                                        color = '#1e325c';
                                    }
                                    if (parseInt(row.result) === 100) {
                                        color = '#008000';
                                    }
                                    return <ProgressBar color={color} value={row.result}></ProgressBar>;
                                }}
                            ></Column>
                        </DataTable>
                    </Dialog>
                )}
            </div>
        );
    }
}

ChallengeListContainer.defaultProps = {
    detailUrl: '/challenge/details',
    newUrl: '/challenge/create',
    editUrl: '/challenge/edit',
    renderChangeLanguegeFilter: true,
    lazy: true,
};

ChallengeListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(ChallengeListContainer));
